import React, { useRef, useState } from 'react';
import { FaFileExcel } from 'react-icons/fa';
import { MdChevronLeft } from 'react-icons/md';
import { CSSTransition } from 'react-transition-group';
import AnimateHeight from 'react-animate-height';
import { Button, Typography } from 'amphitheatre';

import Item, { Content, Label, FileIcon, Icon, Wrapper } from './styled';

const { Header } = Typography;

const PIGIDownload: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const iconRef = useRef(null);

  function onClick(e: React.MouseEvent<HTMLDivElement>) {
    setExpanded(!expanded);
  }

  return (
    <Wrapper>
      <Item className={expanded ? 'expanded' : ''} onClick={onClick}>
        <FileIcon>
          <FaFileExcel />
        </FileIcon>

        <Label>Overpass Data</Label>
        <CSSTransition
          nodeRef={iconRef}
          in={expanded}
          timeout={125}
          classNames="rotate"
        >
          <Icon ref={iconRef}>
            <MdChevronLeft />
          </Icon>
        </CSSTransition>
      </Item>

      <AnimateHeight
        id="download-links"
        duration={125}
        height={expanded ? 'auto' : 0}
      >
        <Content>
          <Header level={3}>Download</Header>
          <a href="https://assets.saberastro.com/quest-for-blue-documents/QFB-Example.xlsx">
            <Button className="primary" fill>
              Template
            </Button>
          </a>
        </Content>
      </AnimateHeight>
    </Wrapper>
  );
};

export default PIGIDownload;
